export const ROOMS_RESULT_URL = `${process.env.NEXT_PUBLIC_BASE_URL_API}listing/rooms`;
export const ROOMS_RESULT_URL_V2 = `${process.env.NEXT_PUBLIC_BASE_URL_API}listing/rooms/v2`;
export const HOTELS_RESULT_URL_V2 = `${process.env.NEXT_PUBLIC_BASE_URL_API}listing/v2/search`;
export const BOOKING_INFO_URL = `${process.env.NEXT_PUBLIC_BASE_URL_API}booking/info/`;
export const BOOKING_GROUP_INFO_URL = `${process.env.NEXT_PUBLIC_GROUP_BASE_URL_API2}booking/info/`;
export const BOOKING_BOOK_URL = `${process.env.NEXT_PUBLIC_BASE_URL_API}booking/book`;
export const GET_BANNERS_URL = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM2}/banners/v1/banner/active`;
export const BOOKING_GROUP_BOOK_URL = `${process.env.NEXT_PUBLIC_GROUP_BASE_URL_API2}booking/book`;
